import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { routes } from "./app.routes";
import { provideHttpClient } from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideNgxMask } from "ngx-mask";
import { appConfigFactory } from "./app-config.factory";
import { ConfigService } from "./services/config.service";
import { DatePipe } from "@angular/common";

export const appConfig: ApplicationConfig = {
    providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideNgxMask(),
    provideAnimations(),
    {
      provide: APP_INITIALIZER,
      useFactory: appConfigFactory,
      deps: [ConfigService],
      multi: true
    },
    DatePipe
  ]
}